import styled from "styled-components";
import { Flex } from "Element/Flex";

export const StyledFaqContainer = styled.div`
  padding: 140px 72px 140px;
  .hero-text {
    margin-top: 0;
    margin-bottom: 96px;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
    padding: 120px 24px;
  `}
`;

export const StyledImg = styled.img`
  width: 147px;
  height: 147px;
  margin-right: 48px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
      width: 120px;
      height: 120px;
      margin-bottom: 24px;
      margin-right: 0;
  `}
`;

export const ContentWrapper = styled(Flex)`
  width: 880px;
  h1 {
    font-size: 28px;
  }
  .content {
    h1 {
      margin-bottom: 12px;
    }
  }
  :not(:last-child) {
    margin-bottom: 96px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        margin-bottom: 48px;
    `}
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width:auto;
    flex-direction: column;
  `}
`;
